const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div id="prototype-thread">
  <div class="o-container--prose o-container">
    <div class="grid o-container__content">
      <div class="first-comment">
        <div class="thread-line"></div>
        <div class="initial-comment">
          <div class="name">
            <div class="avatar"></div>
            <h2 class="username">Kurtis Conner</h2>
          </div>
          <div class="comment-content">
            <p>I’m an example of a longer comment. Llanfairpwllgwyngyllgogerychwyrndrobwllllantysiliogogogoch. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.<p>
            <div class="timestamp">
              <span>2hrs ago</span>
              <a href="#" class="reply">
                <div class="reply-icon"></div>Reply</a>
            </div>
          </div>
        </div>
        <div class="threaded-comment">
          <div class="avatar-username">
            <div class="threaded-avatar"></div>
            <h2 class="username">Paul Hebert</h2>
            <div class="logo-icon"></div>
          </div>
          <div class="threaded-comment-content">
            <p>Thanks for your response!<p>
            <div class="timestamp">
              <span>2hrs ago</span>
            </div>
          </div>
        </div>
      </div>
      <div class="second-comment">
        <div class="name">
          <div class="avatar"></div>
          <h2 class="username">Firstname Lastname-Lastname</h2>
        </div>
        <div class="comment-content">
          <p>I am the start of a new comment.<p>
          <div class="timestamp">
            <span>Feb 16, 2020 via css-tricks.com</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

`);
            }

            getTemplateName() {
                return `61bdac7bb8ec632b6a4868e8514ab12b5498fd590527023b3df8e17c055e31f9`;
            }

            getSourceContext() {
                return new this.Source(``, `61bdac7bb8ec632b6a4868e8514ab12b5498fd590527023b3df8e17c055e31f9`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '61bdac7bb8ec632b6a4868e8514ab12b5498fd590527023b3df8e17c055e31f9');

let template = env.loadTemplate('61bdac7bb8ec632b6a4868e8514ab12b5498fd590527023b3df8e17c055e31f9');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/comment-thread/example/example.twig", args: context }
     );
     return rendered;;
};